import React, { useState, useEffect } from "react";
import CssTransition from "../../component/layout/css-transition";
import Select, { components } from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { Super_Admin } from "../../constant/AuthenticationConstant";
import { RESET_SAVE_TEMPORARY_DATA, SAVE_TEMPORARY_DATA } from "../../redux/constants";
const { MenuList } = components;

function ApproveSendToAdmin({
  openSendToAdminModal,
  setOpenSendToAdminModal,
  handleAccept,
  mappingId,
  reason,
  id,
}) {
  const [dropdownOpt, setDropdownOpt] = useState([]);
  const [value, setValue] = useState();
  const { userData } = useSelector((state) => state.user);
  const { type } = useSelector((state) => state.auth);
  const { saveData, tempPageName } = useSelector(
    (state) => state.tempWindowsData
  );

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    if (userData.length > 0) {
      const arr = [];
      userData.map((item) => {
        arr.push({
          value: item.id,
          label: `${item.first_name} ${item.last_name}`,
        });
      });
      setDropdownOpt(arr);
    }
  }, [userData]);

  useEffect(() => {
    if (tempPageName === "Request") {
      setOpenSendToAdminModal(true);
      setValue(saveData?.user || "");
    }
  }, [tempPageName, saveData]);

  const handleChange = (e) => {
    setValue(e);
  };

  const handleNavigate = () => {
    const formValues = {
      description: reason ?? saveData?.description,
      user: value,
      reqId: id ?? saveData?.reqId,
      activity_assignment_mapping_id: mappingId ?? saveData?.activity_assignment_mapping_id,
    };
    const payload = {
      path: location.pathname,
      tempPageName: "Request",
      saveData: formValues,
    };
    dispatch({ type: SAVE_TEMPORARY_DATA, payload });
    navigate("/users", { state: true });
  };

  // Custome react-select component
  const CustomMenuList = ({ children, ...props }) => (
    <MenuList {...props}>
      {children}
      <div
        className="menu-list"
        onClick={(e) => {
          e.stopPropagation();
          handleNavigate();
        }}
      >
        <i
          class="fa-solid fa-plus fa-xs"
          style={{ paddingRight: "2px", paddingTop: "2px" }}
        ></i>
        Create New User
      </div>
    </MenuList>
  );

  const handleCancel = () => {
    setOpenSendToAdminModal(!openSendToAdminModal);
    setValue("");
    dispatch({ type: RESET_SAVE_TEMPORARY_DATA });
  };

  const handleApprove = () => {
    const activity_assignment_mapping_id = mappingId ?? saveData?.activity_assignment_mapping_id;
    const reqId = id ?? saveData?.reqId;
    handleAccept(value, activity_assignment_mapping_id, reqId);
    setValue("");
    if (tempPageName === "Request") {
      dispatch({ type: RESET_SAVE_TEMPORARY_DATA });
    }
  }

  return (
    <>
      <CssTransition
        className="fixed inset-0 bg-slate-900 bg-opacity-30 z-50 transition-opacity"
        show={openSendToAdminModal}
        enter="transition ease-out duration-200"
        enterStart="opacity-0"
        enterEnd="opacity-100"
        leave="transition ease-out duration-100"
        leaveStart="opacity-100"
        leaveEnd="opacity-0"
        aria-hidden="true"
      />
      <CssTransition
        className="fixed inset-0 z-50 overflow-hidden flex items-center my-4 justify-center px-4 sm:px-6"
        role="dialog"
        aria-modal="true"
        show={openSendToAdminModal}
        enter="transition ease-in-out duration-200"
        enterStart="opacity-0 translate-y-4"
        enterEnd="opacity-100 translate-y-0"
        leave="transition ease-in-out duration-200"
        leaveStart="opacity-100 translate-y-0"
        leaveEnd="opacity-0 translate-y-4"
      >
        <div className="bg-white overflow-auto max-w-2xl w-full max-h-full rounded shadow-lg flex flex-col">
          <div class="py-8 px-6 ">
            <h3 class="mb-8 text-xl font-medium text-gray-900 flex justify-center">
              Approve Reverted To Admin Request
            </h3>
            <div>
              <label className="block text-sm font-medium mb-1 ">
                Reason By User
              </label>
              <textarea
                className="form-input w-[100%] disabled:border-slate-200 resize-none"
                value={reason ?? saveData?.description}
                rows={4}
              />
              <label className="block text-sm font-medium mb-1 ">
                Select User
              </label>
              <Select
                className="basic-single text-sm unresetText"
                classNames={{
                  control: (style) => {
                    return `!border !shadow-sm ${
                      style.isFocused
                        ? "!border-[--bg-color-300]/50"
                        : "!border-slate-200 hover:!border-gray-300"
                    }`;
                  },
                  container: (style) => {
                    return "!h-[37.5px] !font-inter !text-sm";
                  },
                  menuList: (style) => {
                    return `!max-h-[200px]`;
                  },
                }}
                isClearable={true}
                placeholder="Select User"
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                }}
                options={dropdownOpt}
                value={value}
                onChange={handleChange}
                components={ type === Super_Admin ? { MenuList: CustomMenuList } : {}}
              />
            </div>
            <div className="flex justify-end item center my-3 space-x-2">
              <button
                className="btn border-slate-300 hover:border-slate-300 text-slate-600"
                onClick={handleCancel}
              >
                Cancel
              </button>
              <button
                className="btn !bg-[--bg-color-500] hover:!bg-[--bg-color-600] text-white border-1"
                onClick={handleApprove}
              >
                Approve
              </button>
            </div>
          </div>
        </div>
      </CssTransition>
    </>
  );
}

export default ApproveSendToAdmin;
